var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2522 16C3.84893 16 2.52901 15.4527 1.53648 14.4589C-0.512162 12.4074 -0.512162 9.06875 1.53648 7.01737L8.54427 0L9.63822 1.09628L2.63039 8.11272C1.18503 9.56092 1.18503 11.9161 2.63039 13.3634C3.33076 14.0647 4.26225 14.4511 5.2522 14.4511C6.24214 14.4511 7.17368 14.0647 7.874 13.3634L14.8071 6.42097C15.669 5.55791 15.669 4.15443 14.8071 3.29138C13.9718 2.45413 12.5152 2.45671 11.6817 3.29053L4.89217 10.0841C4.74949 10.2269 4.67131 10.4171 4.67131 10.6193C4.67131 10.8216 4.74949 11.0117 4.89301 11.1545C5.17832 11.4428 5.67756 11.4411 5.96287 11.1545L11.6628 5.44775L12.7567 6.54403L7.05767 12.2508C6.15795 13.15 4.69709 13.1483 3.7991 12.2508C2.90108 11.3516 2.90108 9.88704 3.7991 8.98868L10.5886 2.19603C11.2967 1.48612 12.2411 1.09458 13.2448 1.09458C14.2476 1.09458 15.1911 1.48523 15.9018 2.19603C17.3661 3.66315 17.3661 6.05016 15.9018 7.51729L8.96795 14.4589C7.97543 15.4527 6.65635 16 5.2522 16Z",
    fill: "#A2ABBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cea8cc1a58838c6015c591bede08baf7.svg";
export { ForwardRef as ReactComponent };